import { render, staticRenderFns } from "./Marca.vue?vue&type=template&id=11e16389"
import script from "./Marca.vue?vue&type=script&lang=js"
export * from "./Marca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports